/**
 * Common Question Names Constants
 * Standard question/field names used across analytics tracking
 */

export const COMMON_QUESTIONS = {
  /** Brand selection field */
  BRAND: "brand",
  /** Channel/content type selection field */
  CHANNEL: "channel",
  /** Encoded user NTID for tracking (not PII) */
  USER_ENCODED_NTID: "userEncodedNtid",
  /** Session identifier */
  SESSION_ID: "sessionId",
  /** Error code for error tracking */
  ERROR_CODE: "errorCode",
  /** Error reason/message for error tracking */
  ERROR_REASON: "errorReason",
  /** Country selection field */
  COUNTRY: "country",
} as const;

export type CommonQuestionType =
  (typeof COMMON_QUESTIONS)[keyof typeof COMMON_QUESTIONS];
